export default "__VITE_ASSET__965eac94__"